import styled from 'styled-components';

export const ClosingCashierTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ClosingCashierTableRow = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #f6f6f6;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }
`;

export const ClosingCashierTableColumn = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  padding: 20px 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #545454;

  &:last-child {
    border-right: none;
  }

  &:first-child {
    textalign: left;
    flex-basis: 180px;
    min-width: 180px;
  }

  &:nth-child(2) {
    text-align: center;
    flex-basis: 145px;
    max-width: 145px;
  }

  &:nth-child(3) {
    text-align: center;
    flex-basis: 150px;
    max-width: 150px;
    div {
      margin: 0;
    }
  }

  &:nth-child(4) {
    text-align: center;
  }

  input {
    font-size: 16px;
    height: 40px;
    &:disabled {
      cursor: not-allowed;
      color: #33333350;
      background: rgba(239, 239, 239, 0.3);
    }
  }
`;

export const ClosingCashierTableHeader = styled(ClosingCashierTableRow)`
  background: #f6f6f6;

  ${ClosingCashierTableColumn} {
    padding: 12px 16px;
    color: #222;
  }
`;